import { LanguageProvider } from '@/components/LanguageContext';
import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import VideoGallery from '@/components/feature/VideoGallery';
import BeforeAfterGallery from '@/components/feature/BeforeAfterGallery';
import WhySection from '@/components/feature/WhySection';
import ServicesSection from '@/components/feature/ServicesSection';
import TestimonialsSection from '@/components/feature/TestimonialsSection';
import FAQSection from '@/components/feature/FAQSection';
import TouristSection from '@/components/feature/TouristSection';
import SalonSection from '@/components/feature/SalonSection';
import WhatsAppSticky from '@/components/feature/WhatsAppSticky';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <HeroSection />
          <VideoGallery />
          <BeforeAfterGallery />
          <WhySection />
          <ServicesSection />
          <TestimonialsSection />
          <FAQSection />
          <TouristSection />
          <SalonSection />
        </main>
        <Footer />
        <WhatsAppSticky />
      </div>
    </LanguageProvider>
  );
}